import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

export const LogoutModal = ({ isOpen, toggle, centered, handleStayActive, handleLogout, countdown }) => {
    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins < 10 ? '0' : ''}${mins}:
                ${secs < 10 ? '0' : ''}${secs}`;
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            className='deleteCard'
            centered={centered}
        >
            <ModalHeader>
                <h4 className='mb-0 pb-0'>Session Timeout</h4>
            </ModalHeader>

            <ModalBody>
                <p>Your session will automatically expire in {formatTime(countdown)} minutes.</p>
            </ModalBody>

            <ModalFooter>
                <button
                    className='btnLink'
                    onClick={handleLogout}
                >
                    End Session
                </button>
                <button
                    className='btn-primary'
                    onClick={handleStayActive}
                >
                    Continue Session
                </button>
            </ModalFooter>
        </Modal>
    );
};
